<!-- <body class="signuplogin"> -->
  <app-common-header></app-common-header>
  <main role="main" class="maincnt quest">
    <div class="getbannersect sectppad pb-2">
      <div class="sectpad container-fluid">
        <div class="col-sm-12 p-0 webview">         
          <div class="col-12 text-center webview"> 
            <!-- <img src="assets/images/eva-icons.svg" class="signimg prescsimg" /> -->
          </div>
          <div class="col-sm-12 p-0 mt-1 webview preimgmrgn">
            <h1 *ngIf="showText" class="text-center prescsmsg preectlnhgt prelnhgt">Excellent, you answered all of my questions!</h1>
            <h1 *ngIf="showText" class="text-center premsg prelnhgt">Now, let me crunch some numbers and get
              <br> you an Honest Recommendation.</h1>
            <p *ngIf="showText" class="text-center font16 text-muted plsmsg mt-5">Please wait for a few seconds while we find you the best deal</p>
            
          <div id="image-container" style="text-align: center;" *ngIf="!showText">
              <img id="rotating-image" [src]="currentImage" alt="" />
          </div>
           <div style="margin-top: 100px;" *ngIf="!showText">
            
           </div>
            <div class="text-center mt-3 mb-4"><img src="assets/images/loading-old.gif" /></div>
            <p style="font-weight: 600;font-size: 18px" class="text-center" *ngIf="!showText">Fetching exclusive deals from our trusted partners…
            </p>
            <div *ngIf="showText" class="col-sm-12 p-0 text-center">
              <div class="m-auto col-sm-10 col-md-6 col-xl-3 blockbg prebox">
                <img src="assets/images/flash.png" class="mb-1" />
                <p  class="text-center pretipwgt">TIP OF THE DAY</p>
                <p  class="text-center linhgtnor tipmes">The average consumer analyzes at least 3
                  quotes before buying energy. Trust Honest Gorilla to do all the homework for you.</p>
              </div>
            </div>
          </div>
          <div class="col-sm-12 mt-5 mobileview text-center">
            <div class="col-sm-8 pb-4 mb-1">
              <h1 *ngIf="showText" class="text-center text-center font21 font-weight-normal-calibre">Excellent, you answered all of my questions! Now, let me crunch some numbers and get
                <br> you an Honest Recommendation.</h1>
              <!-- <h1 class="text-center">Your Honest Recommendation is Ready!</h1> -->
              <p *ngIf="showText" class="text-center font16 text-muted plsmsg preplsmgn">Please wait for a few seconds while we find you the best deal</p>
              <div id="image-container" style="text-align: center;" *ngIf="!showText">
                <img id="rotating-image" [src]="currentImage" alt="" />
              </div>
              <div style="margin-top: 100px;" *ngIf="!showText">

              </div>
              <div class="text-center mt-3 mb-5"><img src="assets/images/loading-old.gif" /></div>
              <p style="font-weight: 600;font-size: 18px" class="text-center" *ngIf="!showText">Fetching exclusive deals from our trusted partners…
              </p>
              <div *ngIf="showText" class="col-sm-12 p-0 text-center">
                <div class="m-auto col-sm-10 col-md-4 col-xl-4 blockbg pretipbox prebox">
                  <img src="assets/images/flash.png" class="mb-1" />
                  <p class="text-center font-weight-bold-calibre">TIP OF THE DAY</p>
                 <p class="text-center font16 linhgtnor premsg">The average consumer analyzes at least 3
                  quotes before buying energy. Trust Honest</p>
                </div>
               
              </div>
            </div>
           
          </div>
        </div>
        
        <div class="container mobileview mt-0 pt-4">
            <div *ngIf="showText" class="d-flex h-100 row col-sm-12 pr-0 mt-2 mb-3">
                <div class="justify-content-center align-self-center col-sm-3 col-3 pl-0">
                    <img style="width:100% !important;" src="assets/images/signimg.jpg" />
                </div>
                <div class="col-sm-9 col-9 px-0 my-auto">
                    <div class="arrow_box">
                        <h1 class="questionMob text-left">Excellent, you answered all of
                            my questions! Now, let me
                            crunch some numbers and get you an Honest Recommendation.</h1>
                    </div>
                </div>
            </div>
            <p *ngIf="showText" class="col-9 m-auto text-center font16 text-muted plsmsg preplsmgn">Please wait for a few seconds while we find you the best deal</p>
            <div id="image-container" style="text-align: center;padding-top:120px" *ngIf="!showText">
              <img id="rotating-image" [src]="currentImage" alt="" />
            </div>
            <div style="margin-top: 150px;" *ngIf="!showText">

            </div>
            <div class="text-center mt-3 mb-0"><img src="assets/images/loading-old.gif" /></div>
            <p style="font-weight: 600;font-size: 18px;" class="text-center" *ngIf="!showText">Fetching exclusive deals from our trusted partners…
            </p>
            <div *ngIf="showText" class="col-sm-12 p-0 text-center">
              <div class="m-auto col-sm-10 col-md-6 col-xl-4 blockbg prebox">
                <img src="assets/images/flash.png" class="mb-1" />
                <p class="text-center pretipwgt">TIP OF THE DAY</p>
                <p class="text-center linhgtnor tipmes">The average consumer analyzes at least 3 quotes before buying energy. Trust Honest Gorilla to do all the homework for you.</p>
              </div>
            </div>
           
        </div>
      </div>
      </div>
      </main>